import { Injectable, signal } from '@angular/core';
import { IAppConfig } from '../models/app-config';

@Injectable({
  providedIn: 'root',
})
export class AppConfig {
  static settings: IAppConfig = {} as any;

  //TODO redo to app initializer
  static load() {
    const jsonFile = `assets/appsettings.json`;
    return new Promise<void>((resolve, reject) => {
      fetch(jsonFile)
        .then((response) => response.json())
        .then((data) => {
          AppConfig.settings = data as IAppConfig;

          resolve();
        })
        .catch((response: any) => {
          reject(`Could not load file '${jsonFile}': ${JSON.stringify(response)}`);
        });
    });
  }

  // This works because load is 100% executed before this service gets injected at least ones
  public $settings = signal<IAppConfig>(AppConfig.settings);
}
